const PASSWORD_REGEX = /^.*(?=^.{8,14}$)(?=.*\d)(?=.*[a-zA-Z])(?=.*[`.~!@#$%^&*()_+=-]).*$/

export { PASSWORD_REGEX as passwordRegex }
